import { render, staticRenderFns } from "./lawoffswiper.vue?vue&type=template&id=64676847&scoped=true&"
import script from "./lawoffswiper.vue?vue&type=script&lang=js&"
export * from "./lawoffswiper.vue?vue&type=script&lang=js&"
import style0 from "./lawoffswiper.vue?vue&type=style&index=0&id=64676847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64676847",
  null
  
)

export default component.exports